import React from 'react';
import ResenasData from '../../Components/Admin/ResenasData/ResenasData';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const Resenas = () => {
  const { rol } = useSelector((state) => state.auth);

  if (rol !== 'admin') return <Navigate to="/" />;

  return <ResenasData />;
};

export default Resenas;
